<script>
export default {
    props: ['data', 'value', 'placeholder'],
    // props: {
    //     data: Array,
    //     value: Number,
    //     placeholder: String
    // },
    name: "picker",
    data() {
        return {
            isShowOptions: false,
            isTapValue: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
        window.addEventListener('click', this.handleClick);
    },
    destroyed() {
        window.removeEventListener('click', this.handleClick)
    },
    watch: {},
    methods: {
        handleClick() { 
            if (this.isTapValue) { 
                this.isTapValue = false;
                return;
            }
            this.isShowOptions = false;
        },
        tapValue(event) {
            // event.stopPropagation();
            this.isShowOptions = !this.isShowOptions;
            this.isTapValue = true;
        },
        tapOption(event, item, index) { 
            event.stopPropagation();
            this.isShowOptions = false;
            this.$emit('input', index);
            this.$emit('change', index);
        },
    },
};
</script>

<template>
    <div class="picker">
        <div class="value flex flex_colunm align_center justify_between" :class="{active: isShowOptions}" @click="tapValue($event)">
            <span v-if="value != null">{{ data[value].name }}</span>
            <span v-else-if="placeholder">{{ placeholder }}</span>
            <span v-else>请选择</span>
        </div>
        <div class="options" v-if="isShowOptions">
            <div class="item" :class="{active: value == index}" v-for="(item, index) in data" :key="index" @click="tapOption($event, item, index)">{{ item.name }}</div>
        </div>
        <!-- 自动宽度 -->
        <div class="options _options">
            <div class="item" v-for="(item, index) in data" :key="index">{{ item.name }}</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.picker{
    min-width: 1.7rem;
    position: relative;
    z-index: 9;
    white-space: nowrap;
    display: inline-block;
    .value{
        height: .4rem;
        font-size: .18rem;
        border: 1px solid #000;
        padding: 0 .15rem;
        cursor: pointer;
        user-select: none;
        box-sizing: content-box;
        &::after{
            content: '';
            display: block;
            width: .1rem;
            height: .1rem;
            border: 1px solid #000;
            border-width: 0 1px 1px 0;
            transform: translate(0, -25%) rotate(45deg);
        }
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
    }
    .options{
        position: absolute;
        background: #fff;
        width: 100%;
        padding: .1rem 0;
        border: 1px solid #000;
        border-top: 0;
        user-select: none;
        &._options{
            height: 0;
            overflow: hidden;
            position: relative;
            padding: 0;
            border: none;
            padding-right: .3rem;
            box-sizing: content-box;
        }
        .item{
            cursor: pointer;
            font-size: .18rem;
            line-height: .4rem;
            padding: 0 .15rem;
            &.active,
            &:hover{
                background: #f8f8f8;
            }
        }
    }
}
</style>